import { render, staticRenderFns } from "./CVAdditionalRowNew.vue?vue&type=template&id=854db68e"
import script from "./CVAdditionalRowNew.vue?vue&type=script&lang=js"
export * from "./CVAdditionalRowNew.vue?vue&type=script&lang=js"
import style0 from "./CVAdditionalRowNew.vue?vue&type=style&index=0&id=854db68e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports